import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Tooltip } from '@/shared/ui';
import { useAuthStore } from '@/features/auth';
import { useChangelogState } from '../api/queries';
import styles from './VersionBadge.module.css';

export const VersionBadge: React.FC = () => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const { data } = useChangelogState(isAuthenticated);
  const version = data?.version ?? null;
  if (!isAuthenticated || !version) return null;

  const isNew = data?.hasUnread ?? false;
  return (
    <Tooltip content={isNew ? 'Есть новое — посмотреть изменения' : 'Что нового'} side="bottom">
      <Link
        to="/changelog"
        className={styles.badge}
        aria-label={isNew ? `Версия ${version}, есть новое` : `Версия ${version}`}
      >
        <span className={styles.number}>v{version}</span>
        {isNew && (
          <span className={styles.action}>
            <ArrowRight className={styles.arrow} aria-hidden />
          </span>
        )}
      </Link>
    </Tooltip>
  );
};
